<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('manufacturer.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="manufacturer.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('manufacturer.form.fields.status.label')"
            label-for="input-status"
            :description="$t('manufacturer.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="manufacturer.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('manufacturer.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ManufacturerRepository from '@/repositories/vns/ManufacturerRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      manufacturer_id: null
    }
  },
  computed: {
    ...mapGetters({
      manufacturer: 'manufacturer/current',
      isLoading: 'manufacturer/isLoading'
    }),
    pageTitle() {
      if (this.manufacturer_id) return this.$t('manufacturer.form.titulo_pagina.editar')
      return this.$t('manufacturer.form.titulo_pagina.criar')
    }
  },
  methods: {
    ...mapActions([
      'manufacturer/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ManufacturerRepository.post(this.manufacturer).then(() => {
        this.$snotify.success(this.$t('manufacturer.form.create.success'))
        // evt.target.reset()
        this.$router.push({name: 'vns.manufacturer'})
      }).catch(error => {
        this.$snotify.error(this.$t('manufacturer.form.create.error'))
        if (error.response.status === 422) {
          ManufacturerRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ManufacturerRepository.put(this.manufacturer_id, this.manufacturer).then(() => {
        this.$snotify.success(this.$t('manufacturer.form.update.success'))
        this.$router.push({name: 'vns.manufacturer'})
      }).catch(error => {
        this.$snotify.error(this.$t('manufacturer.form.update.error'))
        if (error.response.status === 422) {
          ManufacturerRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('manufacturer/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.manufacturer_id = this.$route.params.id
      await this['manufacturer/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
